import LoginFormContainer from 'tailwind-components/LoginFormContainer/LoginFormContainer';
import propTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import style from './login.module.scss';
import LoginForm from './LoginForm/LoginForm';
import NoMFALoginForm from './NoMFALoginForm/NoMFALoginForm';
import { getCompany } from 'helpers/getCompanyVariables';

const company = getCompany();

function Login({
  siteLoaded,
  setResolver,
  setUserCredentials,
  setEmail,
  setPassword
}) {
  useEffect(() => {
    if (siteLoaded) siteLoaded();
  }, []);

  return (
    <LoginFormContainer>
      {company === 'oneill' ? (
        <LoginForm
          setResolver={setResolver}
          setUserCredentials={setUserCredentials}
          setEmailProp={setEmail}
          setPasswordProp={setPassword}
        />
      ) : (
        <NoMFALoginForm
          setResolver={setResolver}
          setUserCredentials={setUserCredentials}
        />
      )}
      <div className={style.links}>
        <div className={style.forgotPassword}>
          <Link to={'/reset-password'}>Forgot your password?</Link>
        </div>
      </div>
    </LoginFormContainer>
  );
}

Login.propTypes = {
  siteLoaded: propTypes.func,
  setResolver: propTypes.func,
  setUserCredentials: propTypes.func,
  setEmail: propTypes.func,
  setPassword: propTypes.func
};

export default Login;
